import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=3b78217a&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=3b78217a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78217a",
  null
  
)

export default component.exports